import React from "react";
import CellBoolean from "components/table/components/TableRow/CellBoolean";
import { ICourier } from "../../types/courier.interface";
import { Badge, Skeleton } from "@chakra-ui/react";
import { FaMotorcycle } from "react-icons/fa";

interface ICourierProps {
  courier: ICourier;
  isLoading: boolean;
}

const CourierInfo: React.FC<ICourierProps> = (props) => {
  const { courier, isLoading } = props;

  return (
    <section className="my-10">
      {isLoading ? (
        <Skeleton height={7} width={250} rounded={5} />
      ) : (
        <div className="flex flex-col gap-3">
          {courier?.image ? (
            <img
              src={process.env.REACT_APP_PUBLIC_URL + "/" + courier?.image}
              className="h-auto w-full max-w-36 rounded-lg object-contain"
              alt={courier?.name}
            />
          ) : (
            <div className="flex h-20 w-full max-w-36 items-center justify-center rounded-lg bg-brand-50 bg-opacity-25">
              <FaMotorcycle className="h-8 w-8 text-brand-500" />
            </div>
          )}
          <h5 className="mt-2 text-xl font-bold text-navy-700 dark:text-white">
            {courier?.name}{" "}
            <small className="text-gray-600">({courier?.code})</small>
          </h5>
        </div>
      )}
      <section>
        {isLoading ? (
          <Skeleton height={4} width={175} rounded={5} className="mt-2" />
        ) : (
          <div className="mt-5 flex gap-5">
            <div className="flex flex-col gap-2">
              <h6 className="text-base font-semibold text-gray-700">
                Status Kurir
              </h6>
              <CellBoolean
                text={courier?.is_active ? "Aktif" : "Tidak Aktif"}
                status={courier?.is_active}
              />
            </div>
            <div className="flex flex-col gap-2">
              <h6 className="text-base font-semibold text-gray-700">
                Pihak Kurir
              </h6>
              <Badge
                className="text-center text-xl"
                colorScheme={courier?.is_third_party ? "gray" : "green"}
              >
                {courier?.is_third_party ? "Eksternal" : "Internal"}
              </Badge>
            </div>
          </div>
        )}
      </section>
      <section className="mt-5">
        {isLoading ? (
          <div className="flex gap-5">
            <div className="flex flex-col gap-2">
              <Skeleton height={4} width={150} rounded={5} />
              <Skeleton height={4} width={175} rounded={5} />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton height={4} width={150} rounded={5} />
              <Skeleton height={4} width={175} rounded={5} />
            </div>
          </div>
        ) : (
          <div className="flex gap-5">
            <div className="flex flex-col gap-1">
              <h6 className="text-base font-semibold text-gray-700">
                Jarak Maksimal
              </h6>
              <p className="text-lg font-semibold text-navy-700">
                {courier?.max_distance ? courier?.max_distance + " Km" : "-"}
              </p>
            </div>
            <div className="flex flex-col gap-1">
              <h6 className="text-base font-semibold text-gray-700">
                Berat Maksimal
              </h6>
              <p className="text-lg font-semibold text-navy-700">
                {courier?.max_weight
                  ? courier.max_weight.toLocaleString("id-ID") + " Kg"
                  : "-"}
              </p>
            </div>
          </div>
        )}
      </section>
    </section>
  );
};

export default CourierInfo;
